// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"6f9fb817","230":"886f7f21","280":"8c5b15c9","428":"a18e208a","437":"577f93f2","442":"0b473093","447":"96a90951","609":"f513e4eb","659":"d4a8b96c","714":"44f0261e","968":"5ff71522"}[chunkId] + ".chunk.js";
};